import I18n from '../setupI18n';

export default (apiError): string => {
  console.error(JSON.stringify(apiError));

  // errorDescription can be a serialized Error whose details field holds the ATMSWeb error body.
  const rawDescription = apiError.details?.errorDescription;
  const wrappedBody = typeof rawDescription === 'object' ? rawDescription?.details : undefined;
  const errorDescription =
    typeof rawDescription === 'object' ? wrappedBody?.errorDescription : rawDescription;
  const errorName =
    apiError.details?.errorCode ??
    wrappedBody?.errorCode ??
    apiError.details?.errors?.[0]?.name ??
    apiError.details ??
    parseAsyncError(apiError) ??
    JSON.stringify(apiError);
  switch (errorName) {
    case 'JobQualityAssuranceUnresolved':
      return I18n.t('Unresolved QA warnings.');
    case 'NonBilingualFile':
      return I18n.t('The file is not an ATMS supported bilingual table (DOC/DOCX, MXLIFF).');
    case 'JobSegmentsUnconfirmed':
      return I18n.t('Less than 100% segments confirmed. Confirm all segments and then retry.');
    case 'JobNotDownloadable':
      return I18n.t(
        'The translated document cannot be exported, please open the job in the CAT tool and check for QA warnings.'
      );
    case 'JobContainsEmptyTargets':
      return I18n.t(
        'Some segments do not have a translation. Please add a translation to all segments and retry.'
      );
  }

  if (apiError.status === 504 || apiError.status === 408) {
    return I18n.t('The request timed out. Please try again.');
  }

  const message = errorDescription ?? errorName;
  return typeof message === 'object' ? JSON.stringify(message) : `${message}`;
};

const parseAsyncError = apiError => {
  if (apiError.reason) {
    const reason = JSON.parse(apiError.reason);
    const fullError = reason.errors?.[0];

    // Special case for tag mismatch errors
    if (fullError?.includes('Mismatched tags in segment')) {
      // Extract and format user-friendly message
      const parts = fullError.split(':');
      const message = parts
        .slice(2)
        .join(':')
        .trim();

      const segmentMatch = message.match(/Mismatched tags in segment (\d+)/);
      if (segmentMatch) {
        const segmentNum = parseInt(segmentMatch[1]) + 1;
        const jobMatch = message.match(/(Job #\d+ \([^)]+\))/);
        const jobInfo = jobMatch ? jobMatch[1] : 'Job';

        const tagCountMatch = message.match(/expected tag count:(\d+)/);
        const expectedTags = tagCountMatch ? tagCountMatch[1] : null;

        const baseMessage = `${jobInfo}: Mismatched tags in segment ${segmentNum}.`;
        const tagInfo = expectedTags
          ? ` Expected ${expectedTags} tags but found different count.`
          : '';
        const actionMessage = ' Please ensure all source tags are preserved in the target text.';

        return baseMessage + tagInfo + actionMessage;
      }

      return message;
    }

    return fullError
      ?.split(':')
      .pop()
      ?.trim();
  }
};
